export default __webpack_public_path__ + "static/tik-1a2a2e043dbaf67c4c39495597f0d406.svg";